import { render } from "./admissionView.vue?vue&type=template&id=3a4f66ae"
import script from "./admissionView.vue?vue&type=script&lang=js"
export * from "./admissionView.vue?vue&type=script&lang=js"

import "./admissionView.vue?vue&type=style&index=0&id=3a4f66ae&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__